/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Repeat } from 'sushiweb/Icons';
import { Tooltip, CopyText } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';
import { WFHCall } from '../../../commons';
import { Eye, Headset } from 'lucide-react';
import { UserAlternativeNumberCallClickEvent } from '../../../../analytics/call-logging/events';

export const AlternateNumberV1 = ({
  number = '•••••• ••••',
  numberInfo = null,
  calledTo,
  orderId = null,
  userId = null,
  isWFH = false,
  isNewUser = false,
  unmaskNumber = () => {},
  regenerateNumber = () => {},
  alternateContactName = 'Receiver Contact Number',
  cartId = null,
}) => {
  return (
    <div className='tw-flex tw-items-center tw-gap-3'>
      <Headset size={16} className='tw-text-grey-600' strokeWidth={2} />

      <Tooltip
        position='bottom'
        border={false}
        title={
          <div className='tw-text-zinc-600 tw-font-regular'>
            {numberInfo ? (
              <CopyText
                orderId={orderId}
                title={numberInfo.phone}
                masking={false}
                calledTo={calledTo}
                maskEverything={true}
              />
            ) : (
              <div className='tw-flex tw-items-center tw-leading-tight'>
                <span
                  className='tw-min-w-[11rem] tw-whitespace-nowrap tw-text-left'
                  data-dd-privacy='mask'
                >
                  {number}
                </span>
                <Eye
                  size={16}
                  strokeWidth={1.5}
                  className='tw-cursor-pointer tw-text-grey-400 hover:tw-text-grey-500 tw-transition-colors tw-ease-in-out tw-duration-200'
                  onClick={() => unmaskNumber(false)}
                  data-dd-action-name='Unmask Alternate Number'
                />
              </div>
            )}
          </div>
        }
        label={alternateContactName}
      />

      {numberInfo && numberInfo.show_reload_button && (
        <Tooltip
          position='bottom'
          border={false}
          title={
            <div
              className='pointer'
              onClick={() =>
                regenerateNumber(numberInfo.masked_number_popup, false)
              }
            >
              <Repeat size={18} color={grey.z500} />
            </div>
          }
          label='Renew Masked Number'
        />
      )}

      {isWFH ? (
        <WFHCall
          orderId={orderId}
          userId={userId}
          isNewUser={isNewUser}
          pos='top'
          isAltContact={true}
          altContactMissing={true}
          isUser={true}
          calledTo={calledTo}
          sendJumboEvent={true}
          jumboEventFunc={UserAlternativeNumberCallClickEvent}
          JumboEventProperties={{
            is_new_ui: true,
          }}
          cartId={cartId}
        />
      ) : null}
    </div>
  );
};
